<div>
  @if (appLabType === 'twente') {
    <app-nextlab-wrapper [appContent]="content"></app-nextlab-wrapper>
  }
  @if (appLabType === 'iframe') {
    <app-iframe-app-and-lab [ilsModelService]="ilsModelService" [content]="content"
    [i18nKey]="'ilsPlayer'" [player]="true"></app-iframe-app-and-lab>
  }
</div>
